// PermissionContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { RootState } from "../store/store";

const PermissionContext = createContext<{ allowedRoutes: string[], loading: boolean }>({ allowedRoutes: [], loading: true });

// const myStaticData=[
//   {
//       "moduleId": 1,
//       "moduleName": "Society Master",
//       "path": "/society/societymaster",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 2,
//       "moduleName": "Tower Master",
//       "path": "/masters/towermaster",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 3,
//       "moduleName": "Wing Master",
//       "path": "/masters/wingmaster",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 4,
//       "moduleName": "Property Master",
//       "path": "/masters/propertymaster",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 5,
//       "moduleName": "Member Master",
//       "path": "/masters/membersmaster",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 19,
//       "moduleName": "Billings",
//       "path": "/accounts/accounts",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },


//   {
//       "moduleId": 33,
//       "moduleName": "Parent Entity",
//       "path": "/parententity",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 36,
//       "moduleName": "Masters",
//       "path": "#",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 0,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 37,
//       "moduleName": "Applications",
//       "path": "/applications/applications",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },

//   {
//       "moduleId": 39,
//       "moduleName": "Dashboard",
//       "path": "/dashboard/dashboard1",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 40,
//       "moduleName": "Vendor Master",
//       "path": "/vendor/vendormaster",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 1,
//       "read": 1,
//       "update": 1,
//       "delete": 1,
//       "download": 1
//   },
//   {
//       "moduleId": 41,
//       "moduleName": "Roles",
//       "path": "/masters/roles/",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 0,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 42,
//       "moduleName": "Permissions",
//       "path": "#",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 0,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 43,
//       "moduleName": "Mobile App",
//       "path": "/masters/mobileapp/",
//       "parentModuleId": 42,
//       "parentModuleName": "Permissions",
//       "create": 0,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 44,
//       "moduleName": "User",
//       "path": "/masters/userpermission/",
//       "parentModuleId": 42,
//       "parentModuleName": "Permissions",
//       "create": 0,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 47,
//       "moduleName": "Term Condition",
//       "path": "/masters/termscondition",
//       "parentModuleId": 36,
//       "parentModuleName": "Masters",
//       "create": 1,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },

//   {
//       "moduleId": 59,
//       "moduleName": "Complaints",
//       "path": "/complaints/complaints",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 60,
//       "moduleName": "Tenant",
//       "path": "/tenant/tenant",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 61,
//       "moduleName": "Loans",
//       "path": "/loans/loans",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 62,
//       "moduleName": "Notice",
//       "path": "/notices/notices",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },
//   {
//       "moduleId": 63,
//       "moduleName": "Announcement",
//       "path": "/announcement/announcement",
//       "parentModuleId": null,
//       "parentModuleName": null,
//       "create": 1,
//       "read": 0,
//       "update": 0,
//       "delete": 0,
//       "download": 0
//   },


// ]

// const hasAnyPermission = (item: any): boolean =>
//   item.create === 1 || item.view === 1 || item.update === 1 || item.delete === 1 || item.download === 1;

export const PermissionProvider = ({ children }: { children: React.ReactNode }) => {
  const [allowedRoutes, ] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const { isLoggedIn } = useSelector((state: RootState) => state.auth)

  
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        // const res = await getUserModulePermissionApi();
        // if (res.status === 200) {
        //   const routePaths = res.data?.data?.filter((item: any) => hasAnyPermission(item))?.map((item: any) => item?.path?.toLowerCase());
        //   setAllowedRoutes(routePaths);
        // }
      } catch (error) {
        console.error("Error fetching user modules", error);
      } finally {
        setLoading(false);
      }
    };
    if(isLoggedIn){
      fetchPermissions();
    }
  }, [isLoggedIn]);

  return (
    <PermissionContext.Provider value={{ allowedRoutes, loading }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const routePermission = () => useContext(PermissionContext);
